import React from 'react'
import Crud from 'components/platform/Crud'
import { MODAL_NAME } from 'config/modals'
import { renderDate, printName } from 'components/platform/Table/renders'
import NewButton from 'components/platform/Search/NewButton'
import { FormattedMessage } from 'react-intl'

const columns = [
  {
    title: <FormattedMessage id={'global.ticket_number'} />,
    dataIndex: 'name',
    sorter: true,
    className: 'text-center',
    width: 160,
  },
  {
    title: <FormattedMessage id={'global.category'} />,
    dataIndex: 'ticketCategory',
    sorter: true,
    width: 150,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.priority'} />,
    dataIndex: 'ticketPriority',
    sorter: true,
    width: 150,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.severity'} />,
    dataIndex: 'ticketSeverity',
    sorter: true,
    width: 150,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.status'} />,
    dataIndex: 'ticketStatus',
    sorter: true,
    width: 150,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.due_date'} />,
    dataIndex: 'dueDate',
    sorter: true,
    className: 'text-center',
    render: renderDate,
    width: 150,
  },
  {
    title: <FormattedMessage id={'global.created_at'} />,
    dataIndex: 'createdAt',
    sorter: true,
    className: 'text-center',
    render: renderDate,
    width: 110,
  },
  {
    title: <FormattedMessage id={'global.updated_at'} />,
    dataIndex: 'updatedAt',
    sorter: true,
    className: 'text-center',
    render: renderDate,
    width: 130,
  },
]

const TicketsField = ({ contact, account }) => (
  <Crud
    pageLayout={'inline'}
    pageTitle={'Admin tickets'}
    renderSearch={({ modals, getTable }) => (
      <div style={{ fontSize: 20, padding: '10px 0' }} className={'clearfix'}>
        <FormattedMessage id={'global.tickets'} />
        <div className={'pull-right'}>
          <NewButton
            title={<FormattedMessage id={'global.new_ticket'} />}
            onClick={() => {
              modals.open(MODAL_NAME.ticket, {
                itemId: 0,
                onClose: () => {
                  setTimeout(() => getTable().fetch(), 400)
                },
                // onRemoteSaved: (apiResponse) => form.setFieldValue(field.name,[...(field.value || []), apiResponse.data['@id']]),
                defaultItem: { contact, account },
              })
            }}
          />
        </div>
      </div>
    )}
    apiResource={'/api/tickets'}
    modalKey={MODAL_NAME.ticket}
    filters={{ contact, account }}
    searchValues={{ filter: '' }}
    tableSorter={{ field: 'id', order: 'desc' }}
    tableColumns={columns}
  />
)

export default TicketsField
